import { useIntl } from 'react-intl'
import { PageTitle } from '../../../../../_metronic/layout/core'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { StatisticsWidget } from '../../../dashboard/components/StatisticsWidget'
import { FinanceAndAccountsBreadcrum } from '../core/_constants'
import { DataTableServerSide } from '../components/DataTableServerSide'
import { useAuth } from '../../../auth'
import { useEffect, useState } from 'react'
import { getFinanceAccountsStatistics } from '../core/_requests'
import { MultipleStatisticsWidget } from '../../founders-and-promoters/components/multiple-statistics-widget'
import Skeleton from 'react-loading-skeleton'
import { WorldMap } from '../../../widgets/components/General/WorldMap'
import { PieChartWidget } from '../../../widgets/components/General/PieChartWidget'
import NothingToShow from '../../../captable-management/components/NothingToShow'

export const FinanceAndAccounts = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const [dashboardLoading, setDashboardLoading] = useState(false)

  const [dashboardCounts, setDashboardCounts] = useState({
    financeAccountsCount: {
      financeAccountsIndividuals: {
        financeAccountsIndividualsTotalCount: 0,
        financeAccountsIndividualsCountByDay: [],
      },
      financeAccountsInstitutions: {
        financeAccountsInstitutionsTotalCount: 0,
        financeAccountsInstitutionsCountByDay: [],
      },
      totalfinanceAccountsCount: 0,
    },

    countriesCount: {
      indianCountryCount: 0,
      otherCountriesCount: [
        {
          countryId: 0,
          countryName: '',
        },
      ],
      totalOtherCountriesCount: 0,
      totalCountriesCount: 0,
    },
    genderCounts: {
      totalGenderCount: 0,
      male: 0,
      female: 0,
      other: 0,
    },
    complianceMeetingAvgAcceptCount: {
      avgAcceptRatio: 0,
      acceptedMeetingsByDate: {
        'Tue Sep 10 2024': 0,
        'Wed Sep 11 2024': 0,
        'Thu Sep 12 2024': 0,
        'Fri Sep 13 2024': 0,
        'Sat Sep 14 2024': 0,
        'Sun Sep 15 2024': 0,
        'Mon Sep 16 2024': 0,
      },
    },
  })
  const { companyId } = useAuth()

  console.log(dashboardCounts, 'dashboardCounts')

  const getDashboardCounts = async () => {
    setDashboardLoading(true)
    try {
      const {
        data: { data },
      } = await getFinanceAccountsStatistics(companyId!)
      if (data) {
        setDashboardCounts(data)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setDashboardLoading(false)
    }
  }

  useEffect(() => {
    getDashboardCounts()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <PageTitle
        breadcrumbs={FinanceAndAccountsBreadcrum}
        description={formatMessage({ id: 'Finance and Accounts' })}
      >
        {formatMessage({ id: 'Finance and Accounts' })}
      </PageTitle>

      {/* button for Desktop view */}
      <div
        // className={`d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block ${planStatus === 'payment_due' && 'planstatus-adjustment'}  ${planStatus === 'paid' && 'planstatus-not-adjustment'}`}
        className='d-flex align-items-center justify-content-end position-absolute gap-2 gap-lg-3 d-none d-sm-block'
        style={{ top: '80px', right: '30px' }}
      >
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100`}
              onClick={() => navigate('../add-finance-and-accounts')}
            >
              {formatMessage({ id: 'Add Finance And Accounts' })}
            </button>
          </div>
        </div>
      </div>
      {/* button for mobile view */}
      <div className='d-flex align-items-center gap-2 gap-lg-3 d-block d-sm-none'>
        <div className='d-flex flex-column mt-3 top-btn-main'>
          <div className='d-flex justify-content-end'>
            <button
              className={`btn bg-primary custom-button-property font-size-13 text-white font-weight-400 w-100`}
              onClick={() => navigate('../add-finance-and-accounts')}
            >
              {formatMessage({ id: 'Add Finance And Accounts' })}
            </button>
          </div>
        </div>
      </div>

      {dashboardLoading ? (
        <Row className={`my-4`}>
          {[1, 2, 3, 4].map((item) => (
            <Col md={6} lg={3} key={item}>
              <div
                className='bg-white   rounded-2 mb-4 p-6'
                style={{ width: '100%', height: '270px' }}
              >
                <div className='mb-2'>
                  <Skeleton
                    width={'100%'}
                    height={20}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>

                <div className='d-flex justify-content-between mb-2'>
                  <div>
                    <Skeleton
                      width={'5vw'}
                      height={40}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div>
                    <Skeleton
                      width={'5vw'}
                      height={40}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />{' '}
                  </div>
                </div>

                <div className='mb-2'>
                  <Skeleton
                    width={'100%'}
                    height={150}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        <Row className={`mt-6`}>
          <Col md={6} lg={3}>
            <div className='bg-white p-6  rounded-2 mb-4' style={{ height: '300px' }}>
              {dashboardCounts?.financeAccountsCount?.totalfinanceAccountsCount === 0
                ?
                <div className='stats-card-top'>
                  <p className='mb-0 text-muted mb-4'>
                    {formatMessage({ id: 'Finance & accounts Counts' })}
                  </p>
                  <NothingToShow />
                </div>
                :
                <>
                  <div className='stats-card-top'>
                    <p className='mb-0 text-muted mb-4'>
                      {formatMessage({ id: 'Finance & accounts Counts' })}
                    </p>
                    <div className='d-flex flex-row justify-content-between align-items-center mt-6'>
                      <h1 className='mb-0 dark_text_color font-size-32'>
                        {' '}
                        {dashboardCounts?.financeAccountsCount?.totalfinanceAccountsCount}
                      </h1>
                      <div className='w-50'>
                        <div className='d-flex justify-content-between font-size-12 mb-1'>
                          <span>
                            <span className='light-blue-circle me-1'></span>{formatMessage({ id: 'Individuals' })}
                          </span>
                          <span>
                            {
                              dashboardCounts.financeAccountsCount.financeAccountsIndividuals
                                .financeAccountsIndividualsTotalCount
                            }
                          </span>
                        </div>
                        <div className='d-flex justify-content-between font-size-12 mb-1'>
                          <span>
                            <span className='strong-blue-circle me-1'></span>{formatMessage({ id: 'Institutions' })}
                          </span>
                          <span>
                            {
                              dashboardCounts.financeAccountsCount.financeAccountsInstitutions
                                .financeAccountsInstitutionsTotalCount
                            }
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <MultipleStatisticsWidget
                      className='card-xl-stretch mb-xl-1'
                      color={['blue', '#062EC6']}
                      statisticsData={[
                        dashboardCounts?.financeAccountsCount?.financeAccountsIndividuals
                          .financeAccountsIndividualsCountByDay as any,
                        dashboardCounts?.financeAccountsCount?.financeAccountsInstitutions
                          ?.financeAccountsInstitutionsCountByDay as any,
                      ]}
                      label={['individuals', 'institutions']}
                    />
                  </div>
                </>
              }
            </div>
          </Col>

          <Col md={6} lg={3}>
            <div className='bg-white p-6 rounded-2 mb-4' style={{ height: '300px' }}>
              {dashboardCounts?.complianceMeetingAvgAcceptCount?.avgAcceptRatio === 0
                ?
                <div className='stats-card-top'>
                  <p className='mb-0 text-muted mb-4'>
                    {formatMessage({ id: 'Average Accept Invite' })}
                  </p>
                  <NothingToShow />
                </div>
                :
                <>
                  <div className='stats-card-top'>
                    <p className='mb-0 text-muted mb-4'>
                      {formatMessage({ id: 'Average Accept Invite' })}
                    </p>
                    <div className='d-flex flex-row align-items-center mt-6'>
                      <h1 className='mb-0 dark_text_color font-size-32'>
                        {Number.isInteger(
                          dashboardCounts?.complianceMeetingAvgAcceptCount?.avgAcceptRatio
                        )
                          ? dashboardCounts.complianceMeetingAvgAcceptCount.avgAcceptRatio
                          : dashboardCounts.complianceMeetingAvgAcceptCount.avgAcceptRatio.toFixed(2)}
                        %
                      </h1>
                    </div>
                  </div>
                  <div>
                    <StatisticsWidget
                      className='card-xl-stretch mb-xl-1'
                      color='dark'
                      statisticsData={
                        dashboardCounts?.complianceMeetingAvgAcceptCount?.acceptedMeetingsByDate
                      }
                      label='Finances & Accounts'
                    />
                  </div>
                </>
              }
            </div>
          </Col>

          <Col md={6} lg={3}>
            <div className='bg-white p-6 pb-0 rounded-2 mb-4' style={{ height: '300px' }}>
              <div className='stats-card-top'>
                <p className='mb-0 text-muted mb-4'>
                  {formatMessage({ id: 'Finance & Accounts By Country' })}
                </p>
                <div className='d-flex flex-row align-items-center justify-content-between mt-3'>
                  <h1 className='mb-0 dark_text_color font-size-32'>
                    {dashboardCounts.countriesCount.totalCountriesCount}
                  </h1>
                  <div className='w-50'>
                    <div className='d-flex justify-content-between font-size-12 mb-1'>
                      <span>
                        <span className='light-blue-circle me-1'></span>{formatMessage({ id: 'India' })}
                      </span>
                      <span>{dashboardCounts.countriesCount.indianCountryCount}</span>
                    </div>
                    <div className='d-flex justify-content-between font-size-12 mb-1'>
                      <span>
                        <span className='strong-blue-circle me-1'></span>{formatMessage({ id: 'Non-India' })}
                      </span>
                      <span>{dashboardCounts.countriesCount.totalOtherCountriesCount}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <WorldMap dashboardCounts={dashboardCounts} />
              </div>
            </div>
          </Col>

          <Col md={6} lg={3}>
            <div className='bg-white p-4 pt-6 rounded-2 mb-4' style={{ height: '300px' }}>
              {!dashboardCounts.genderCounts.male && !dashboardCounts.genderCounts.female && !dashboardCounts.genderCounts.other
                ?
                <div className='stats-card-top'>
                  <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Gender' })}</p>
                  <NothingToShow />
                </div>
                :
                <>
                  <div className='stats-card-top'>
                    <p className='mb-0 text-muted mb-4'>{formatMessage({ id: 'Gender' })}</p>
                  </div>
                  <div>
                    <PieChartWidget
                      data={[
                        { name: 'Male', value: dashboardCounts.genderCounts.male },
                        { name: 'Female', value: dashboardCounts.genderCounts.female },
                        { name: 'Others', value: dashboardCounts.genderCounts.other },
                      ]}
                      colors={['#0D216D', '#1D3EB9', '#4776E6']}
                    />
                  </div>
                </>
              }
            </div>
          </Col>
        </Row>
      )}

      <DataTableServerSide getDashboardCounts={getDashboardCounts} />
    </>
  )
}
